import { RecordCard, RecordRow } from "./RecordCard";
import { MUTED } from "./styles";

/** One person on a record, in a role (record_assignments, 0021, W15 M5). */
export interface Assignment {
  id: string;
  role: string;
  role_label: string;
  user_id: string;
  user_name: string;
  user_contact_id: string | null;
  valid_from: string;
}

/** Who works this record (owner, paired loan officers, processors). Read-only. */
export function TeamCard({ assignments }: { assignments?: Assignment[] }) {
  if (!assignments?.length) return null;
  return (
    <RecordCard title="Assigned to" count={assignments.length}>
      <ul>
        {assignments.map((a) => (
          <RecordRow
            key={a.id}
            primary={
              // Plain text: the person's contact is already linked from the
              // page's own cards (parties, members), and a second link to it
              // on every record is noise.
              <>
                <span>{a.user_name}</span>{" "}
                <span className={MUTED}>— {a.role_label.toLowerCase()}</span>
              </>
            }
            secondary={`since ${a.valid_from}`}
          />
        ))}
      </ul>
    </RecordCard>
  );
}
